export interface SeedRateRange {
  min: number;
  max: number;
}

export interface SeedAssignmentErrors {
  product?: string;
  rate?: string;
}

export type SeedRateError =
  | { kind: "required" }
  | { kind: "range"; min: number; max: number };

export const validateSeedRate = (
  value: number | null,
  range?: SeedRateRange
): SeedRateError | undefined => {
  if (value === null || !Number.isFinite(value) || value <= 0) {
    return { kind: "required" };
  }

  if (range && (value < range.min || value > range.max)) {
    return {
      kind: "range",
      min: range.min,
      max: range.max,
    };
  }

  return undefined;
};
